<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <!--                                <div v-if="$can('History', 'all')">-->
                <!--                                    <a>Add Post</a>-->
                <!--                                </div>-->

                <label>Causer Name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Causer Name"
                  v-model="causer_name"
                  @keyup.enter="doFilter"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <div slot="footer" class="search-panel-btn">
            <b-button
              type="submit"
              size="sm"
              variant="primary"
              class="search-btn"
              @click="doFilter"
              ><i class="cui-magnifying-glass icons"></i> Search</b-button
            >
            <b-button
              type="reset"
              size="sm"
              variant="danger"
              @click="resetFilter"
              ><i class="cui-ban icons"></i> Reset</b-button
            >
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      causer_name: ""
    };
  },
  methods: {
    doFilter() {
      let filters = {
        causer_name: this.causer_name
      };
      this.$events.fire("filter-set", filters);
    },
    resetFilter() {
      this.causer_name = "";
      this.$events.fire("filter-reset");
    }
  }
};
</script>

<style scoped>
.search-panel-btn {
  float: right;
}

.search-btn {
  margin-right: 5px;
}
</style>
